var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('GenericListTable',{attrs:{"parentID":this.parentID,"title":"Project Groups","headers":[
      { text: 'ID', value: 'id' },
      { text: 'Project Group Name', value: 'groupname' },
      { text: 'Project Group Description', value: 'description' }
    ],"url":"/schemas/projectgroups","apiResponseField":"projectgroups","onClickRoute":"ProjectGroupSingle","onClickParams":_vm.getOnClickParams}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }